import axios from 'axios';

// Support both env var names for flexibility (Railway uses REACT_APP_API_URL)
const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL || '';
const API_BASE_URL = `${API_URL}/api`;

// Defensive guard: a local dev server must never silently talk to the real
// production backend (real money, real webhooks, real user data). This closes
// a P0 finding where frontend/.env.development.local pointed straight at the
// production Railway host, so `npm start` talked to prod with no warning.
// Only fires for `npm start` (NODE_ENV==='development'); a real Vercel
// production build is NODE_ENV==='production' and correctly targets this host
// on purpose, so it is unaffected.
const KNOWN_PRODUCTION_BACKEND_HOST = 'trusttrade-backend-production-3efa.up.railway.app';
if (
  (process.env.NODE_ENV === 'development' || process.env.REACT_APP_RUNTIME_CLASSIFICATION === 'sit') &&
  typeof API_URL === 'string' &&
  API_URL.includes(KNOWN_PRODUCTION_BACKEND_HOST)
) {
  throw new Error(
    'Refusing to start: local dev build (NODE_ENV=development) is configured to talk to ' +
    `the PRODUCTION backend (${API_URL}). This would run against real customer data, ` +
    'payments, and webhooks. Fix frontend/.env.development.local (or REACT_APP_API_URL) ' +
    'to point at a local/staging backend, e.g. http://localhost:8001.'
  );
}

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  timeout: 30000,
});

// Request interceptor to add Authorization header from localStorage
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('session_token');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401s are handled by ProtectedRoute — don't clear token here
    return Promise.reject(error);
  }
);

export default api;
export { API_URL, API_BASE_URL };
